import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '@mui/material/Avatar';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';


import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';

import AffectationsIndicateursTable from './AffectationsIndicateursTable';
import withLoader from 'components/Shared/withLoader';



const AffectationsIndicateursTableWithLoader = withLoader(AffectationsIndicateursTable);

const AffectationsIndicateurs = ({ isLoading, groupes, selectedGroupeIndexes, onGroupeChange, criteres, onChange }) => {

    const [expanded, setExpanded] = React.useState(false);

    let affectations = {
        groupes: [],
        nombreNonAffecteesTotal: 0,
        nombreEnCoursTotal: 0,
        nombreAffecteesTotal: 0,
        nombreClotureesTotal: 0
    };

    if (groupes && groupes[0] && selectedGroupeIndexes.length > 0) {

        affectations.groupes = selectedGroupeIndexes.map(x => {

            var groupe = { ...groupes[x] };

            groupe.affectations = groupe.affectations.sort((a, b) => a.nombreEnCours === b.nombreEnCours ? a.utilisateur > b.utilisateur : b.nombreEnCours - a.nombreEnCours);

            return {
                ...groupe,
                nombreEnCoursTotal: groupes[x].affectations.reduce((accumulator, affectation) => accumulator + affectation.nombreEnCours, 0),
                nombreAffecteesTotal: groupes[x].affectations.reduce((accumulator, affectation) => accumulator + affectation.nombreAffectees, 0),
                nombreClotureesTotal: groupes[x].affectations.reduce((accumulator, affectation) => accumulator + affectation.nombreCloturees, 0)
            };
        });
        
        affectations.nombreNonAffecteesTotal = affectations.groupes.reduce((accumulator, groupe) => accumulator + groupe.nombreNonAffectees, 0);

        affectations.nombreEnCoursTotal = affectations.groupes.reduce((accumulator, groupe) => accumulator + groupe.nombreEnCoursTotal, 0);
        affectations.nombreAffecteesTotal = affectations.groupes.reduce((accumulator, groupe) => accumulator + groupe.nombreAffecteesTotal, 0);
        affectations.nombreClotureesTotal = affectations.groupes.reduce((accumulator, groupe) => accumulator + groupe.nombreClotureesTotal, 0);
    }
        

    return (

        <Accordion expanded={expanded} onChange={e => { setExpanded(!expanded); }} TransitionProps={{ mountOnEnter: true, unmountOnExit: false }}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{marginRight: '40px'}} />}
            >
                <Avatar><AssignmentIndIcon /></Avatar>
                <Stack direction={"column"} sx={{ marginLeft: '8px' }}>
                    <Typography variant="subtitle1">Affectations</Typography>
                    <Typography variant="subtitle2">Nombre de dossiers après-vente en cours par groupe et utilisateur</Typography>
                </Stack>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={3} sx={{ marginBottom: '8px' }}>

                    <Grid item xs={8}>
                        {groupes && groupes[0] && (

                            <TextField
                                id={"groupe"}
                                name={"groupe"}
                                label={"Groupe(s) de traitement"}
                                fullWidth
                                disabled={groupes.length === 1}

                                select
                                SelectProps={{
                                    multiple: true,
                                    value: selectedGroupeIndexes,
                                    onChange: onGroupeChange,
                                    renderValue: (values) => {
                                        return (values.map(value => groupes[value].libelle).join(', '));
                                    }
                                }}


                            >
                                <MenuItem value="" disabled>Sélectionner un ou plusieurs groupes</MenuItem>

                                {groupes.map((groupe, index) => (
                                    <MenuItem key={index} value={index}>

                                        <Checkbox checked={selectedGroupeIndexes.indexOf(index) > -1} />
                                        <ListItemText primary={groupe.libelle} />
                                    </MenuItem>
                                ))}

                            </TextField>

                        )}
                    </Grid>


                    <Grid item xs={2}>
                        <TextField
                            id="dateCreationDebut"
                            name="dateCreationDebut"
                            label="Début"
                            type="date"
                            fullWidth
                            value={criteres.dateCreationDebut}
                            onChange={onChange}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            id="dateCreationFin"
                            name="dateCreationFin"
                            label="Fin"
                            type="date"
                            fullWidth
                            value={criteres.dateCreationFin}
                            onChange={onChange}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                </Grid>

                <AffectationsIndicateursTableWithLoader isLoading={isLoading} affectations={affectations} />

            </AccordionDetails>
        </Accordion>
    );
};

AffectationsIndicateurs.propTypes = {
    groupes: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired
};

export default AffectationsIndicateurs;